console.log(process.env);
export const FIREBASE_CONFIG = JSON.parse(process.env.SELLER_HUB_FIREBASE);
